import type * as TabMenu from '../types/TabMenu'

export default function (rawComponent: TabMenu.Raw): TabMenu.Parsed {
  const { tabMenu } = rawComponent.tabMenuComponent
  const { links } = tabMenu

  return {
    name: 'TabMenu',
    props: {
      links,
    },
  }
}
